var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      staticClass: "_component-login-modal",
      attrs: { clickOverlayClose: false }
    },
    [
      _c(
        "div",
        { staticClass: "component-login-modal" },
        [
          _c("Login", {
            ref: "login",
            attrs: { options: _vm.options, initState: _vm.initState },
            on: { changeState: _vm.handleChangeState }
          }),
          _vm.isShowClose
            ? _c("div", {
                staticClass: "close-render",
                on: { click: _vm.handleClickClose }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.initState !== _vm.LOGIN_STATE.FIND_PASSWORD
        ? _c("Welfare", {
            staticClass: "welfare-wrap mt-12",
            attrs: { modal: "" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }